import { useTranslation } from "react-i18next";

export default function HardwareGrid() {
  const { t } = useTranslation("pages");

  const devices = [
    { name: "AIM Solo 2 DL", sub: t("home.mock.hardware.aim") },
    { name: "RaceBox", sub: t("home.mock.hardware.racebox") },
    { name: "RaceChrono", sub: t("home.mock.hardware.racechrono") },
    { name: "Trackcast", sub: t("home.mock.hardware.trackcast") },
  ];

  return (
    <ul className="grid grid-cols-2 gap-2.5">
      {devices.map((d) => (
        <li
          key={d.name}
          className="rounded-xl border border-gray-800 bg-gray-900/60 p-4"
        >
          <span className="block text-sm font-semibold text-white">{d.name}</span>
          <span className="text-xs text-gray-400">{d.sub}</span>
        </li>
      ))}
    </ul>
  );
}
